
const elementFields = {
    basic: {
        title: null,
        fields: {
            comment: {
                control: "string",
                title: "Comment",
                titlePosition: "prefix",
                width: "100%"
            }
        },
    },
    asset: {
        title: "Asset",
        fields: {
            src: {
                control: "string",
                title: "Source URL",
                titlePosition: "placeholder",
                width: "100%"
            },
            component: {
                control: "string",
                title: "Component",
                titlePosition: "prefix",
                width: "100%",
                disabled: true
            },
            text: {
                type: "string",
                control: "stringMultiline",
                title: "Text",
                titlePosition: "prefix",
                width: "100%"
            },
            html: {
                type: "string",
                control: "stringMultiline",
                title: "HTML",
                titlePosition: "placeholder",
                width: "100%"
            },
            tailwindcss: {
                type: "boolean",
                title: "Use Tailwind CSS",
                titlePosition: "prefix",
                width: "100%"
            },
            voice: {
                control: "string",
                title: "Voice",
                titlePosition: "prefix",
                width: "100%"
            },
            style: {
                control: "string",
                title: "Style",
                disabled: true,
                titlePosition: "prefix",
                width: "50%"
            },
            cache: {
                control: "boolean",
                title: "Cache",
                titlePosition: "prefix",
                width: "50%"
            },
            loop: {
                control: "integer",
                title: "Loop",
                titlePosition: "prefix",
                width: "50%",
                unit: "times"
            },
            seek: {
                title: "Seek",
                titlePosition: "prefix",
                width: "100%",
                unit: "s"
            },
            volume: {
                control: "float",
                title: "Volume gain",
                titlePosition: "prefix",
                width: "50%",
                unit: ""
            },
            muted: {
                control: "boolean",
                title: "Muted",
                titlePosition: "prefix",
                width: "50%"
            },
            amplitude: {
                title: "Amplitude",
                titlePosition: "prefix",
                width: "50%"
            },
            opacity: {
                title: "Opacity",
                titlePosition: "prefix",
                width: "50%"
            },
            color: {
                control: "color",
                title: "Color",
                titlePosition: "prefix",
                width: "100%"
            },
            captions: {
                title: "Captions",
                titlePosition: "prefix",
                control: "stringMultiline",
                width: "100%"
            },
            language: {
                title: "Language of the audio",
                titlePosition: "prefix",
                width: "100%"
            }
        },
    },
    componentSettings: {},
    position: {
        title: "Position, scale and rotate",
        fields: {
            position: {
                title: "Position",
                titlePosition: "prefix",
                width: "100%"
            },
            x: {
                title: "X",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            },
            y: {
                title: "Y",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            },
            "width": {
                title: "W",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            },
            "height": {
                title: "H",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            },
            "rotate.angle": {
                title: "Rotate",
                titlePosition: "prefix",
                width: "50%",
                unit: "deg"
            },
            "z-index": {
                title: "z-index",
                titlePosition: "prefix",
                width: "100%"
            }
        },
    },
    timeline: {
        title: "Timeline",
        fields: {
            duration: {
                title: "Duration",
                titlePosition: "prefix",
                width: "100%",
                unit: "s"
            },
            start: {
                title: "Start",
                titlePosition: "prefix",
                width: "50%",
                unit: "s"
            },
            "extra-time": {
                title: "Extra",
                titlePosition: "prefix",
                width: "50%",
                unit: "s"
            },
            "fade-in": {
                title: "Fade in",
                titlePosition: "prefix",
                width: "50%",
                unit: "s"
            },
            "fade-out": {
                title: "Fade out",
                titlePosition: "prefix",
                width: "50%",
                unit: "s"
            }
        },
    },
    zoompan: {
        title: "Zoom and pan",
        fields: {
            zoom: {
                title: "Zoom",
                titlePosition: "prefix",
                width: "50%"
            },
            pan: {
                title: "Pan",
                titlePosition: "prefix",
                width: "100%"
            },
            "pan-distance": {
                title: "Distance",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            }
        },
    },
    correction: {
        title: "Adjustments",
        fields: {
            "correction.contrast": {
                title: "Contrast",
                titlePosition: "prefix",
                width: "50%"
            },
            "correction.brightness": {
                title: "Brightness",
                titlePosition: "prefix",
                width: "50%"
            },
            "correction.saturation": {
                title: "Saturation",
                titlePosition: "prefix",
                width: "50%"
            },
            "correction.gamma": {
                title: "Gamma",
                titlePosition: "prefix",
                width: "50%"
            },
            "flip-horizontal": {
                control: "boolean",
                title: "Flip horizontal",
                titlePosition: "prefix",
                width: "100%"
            },
            "flip-vertical": {
                control: "boolean",
                title: "Flip vertical",
                titlePosition: "prefix",
                width: "100%"
            }
        },
    }
};

const sceneFields = {
    basic: {
        title: null,
        fields: {
            comment: {
                control: "string",
                title: "Comment",
                titlePosition: "placeholder",
                width: "100%"
            },
            cache: {
                control: "boolean",
                title: "Cache",
                titlePosition: "prefix",
                width: "50%"
            },
            "background-color": {
                control: "color",
                title: "Background",
                titlePosition: "prefix",
                width: "100%"
            },
            duration: {
                title: "Scene duration",
                titlePosition: "prefix",
                width: "100%",
                unit: "s"
            },
            "z-index": {
                title: "z-index",
                titlePosition: "prefix",
                width: "100%"
            }
        },
    },
    transition: {
        title: "Transition",
        fields: {
            "transition.style": {
                title: "Style",
                titlePosition: "prefix",
                width: "100%"
            },
            "transition.duration": {
                title: "Transition duration",
                titlePosition: "prefix",
                width: "100%",
                unit: "s"
            }
        },
    }
};

const movieFields = {
    basic: {
        title: null,
        fields: {
            comment: {
                control: "string",
                title: "Comment",
                titlePosition: "placeholder",
                width: "100%"
            },
            resolution: {
                control: "string",
                title: "Resolution",
                titlePosition: "prefix",
                width: "100%"
            },
            width: {
                control: "integer",
                title: "Width",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            },
            height: {
                control: "integer",
                title: "Height",
                titlePosition: "prefix",
                width: "50%",
                unit: "px"
            }
        }
    }
}

export default function VEFieldsConfig(itemType) {
    switch(itemType) {
        case "element": return elementFields;
        case "scene": return sceneFields;
        case "movie": return movieFields;
        default: return elementFields;
    }
}